import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 75px;

  ${media.lg`
    height: 177px;
  `}
`;

export const Inner = styled.div<{ isActive: boolean | null }>`
  height: 100%;
  color: ${({ theme, isActive }: any) =>
    isActive ? theme.defaultColors.fontPrimary : theme.defaultColors.grey};
  border: ${({ theme, isActive }: any) =>
    isActive
      ? `2px solid ${theme.defaultColors.grey}`
      : `2px dashed ${theme.defaultColors.lightGrey}`};
  position: absolute;
  display: grid;
  justify-items: center;
  width: 75px;
  padding-top: 0;
  align-items: center;
  cursor: pointer;
  background-image: none !important;
  overflow: hidden;

  ${media.lg`
    width: 100%;
    padding-top: 65px;
    display: block;
    text-align: center;
  `}
`;

export const BgImageWrapper = styled.div`
  position: absolute;
  filter: blur(4px) opacity(50%);
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  margin: -4px;
  bottom: 0px;
`;

export const BgImage = styled(BackgroundImgixWrapper)`
  width: 100%;
  height: 100%;
`;

export const Text = styled.div<{ isActive: boolean | null }>`
  font-size: 14px;
  color: ${({ theme, isActive }) =>
    isActive ? theme.defaultColors.fontPrimary : theme.defaultColors.fontSecondary};
  text-transform: uppercase;
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  padding-left: 100px;
  align-content: center;
  text-align: left;
  right: 0;
  top: 0;

  ${media.lg`
    padding-left: 0;
    padding-top: 40px;
    text-align: center;
    color: ${({ theme, isActive }: any) =>
      isActive ? theme.customColors.fontPrimary : theme.defaultColors.grey};
  `}
`;

export const ReadyToCheckout = styled(Text)`
  top: 20px;
  ${media.lg`
    display: none;
  `}
`;
